import React from 'react';
import { TournamentLink } from 'views/Tournament/TournamentLink';
import { makeStyles } from '@material-ui/core/styles';
import { useQuery } from '@apollo/client';
import { RouteComponentProps } from 'react-router-dom';
import { Box, CircularProgress } from '@material-ui/core';
import { DuelData, DuelQuery, DuelVars } from '@pvplevelup/core/dist/queries/duel/duel';
import { DuelBreakdown } from './DuelBreakdown';
import { RecordVideos } from 'components/Video/RecordVideos';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(2),
    maxWidth: 1400,
    margin: '0 auto',
  },
  empty: {
    padding: theme.spacing(6, 2),
    textAlign: 'center',
    color: 'rgba(255, 255, 255, 0.6)',
  },
}));

interface RouteParams {
  id: string;
}

export const DuelSummary: React.FC<RouteComponentProps<RouteParams>> = (props) => {
  const classes = useStyles();

  const { data, loading } = useQuery<DuelData,DuelVars>(
    DuelQuery,
    { variables: {id:props.match.params.id},fetchPolicy:'cache-and-network' }
  );

  let duel = data?.duel;
  if(!duel)
    return loading ? <Box p={6} textAlign="center"><CircularProgress /></Box> : <div className={classes.empty}>Duel not found.</div>;

  return (
    <section className={classes.container}>
      <DuelBreakdown duel={duel} actions={<TournamentLink tournament={(duel as any).tournament} />} />
      <RecordVideos entries={(duel.performances || []).map((p: any) => ({user: p.user, name: p.name || p.character?.name, video: p.video}))} />
    </section>
  );
}
